import React from 'react';
import { Routes as RoutePaths } from "../CEF/Common/Constants";
import { MemoryRouter } from 'react-router-dom';
import { OnboardingRoutes } from "./OnboardingRoutes";
export function OnboardingRouter(props) {
  var initialRoute = RoutePaths.Preferences.CountriesPage;
  return /*#__PURE__*/React.createElement(MemoryRouter, {
    initialEntries: [initialRoute]
  }, /*#__PURE__*/React.createElement(OnboardingRoutes, {
    onExit: props.onExit,
    onSave: props.onSave
  }));
}